import * as params from '../movenet/params'
import { isRemoteControl } from '../utils/assessment-control'


class RaisedHand{
    constructor(hand, raised, id){
        this.hand = hand;
        this.raised = raised;
        this.id = id;
    }
}

export class GestureDetector
{
    constructor(gesture_hold_time_ms=3000){
    this.gesture_hold_time_ms = gesture_hold_time_ms;
    this.gesture_hold_frame_count = 40;
    this.gesture_detected_frame_count = 0;
    this.joint_confidence_threshold = 0.11;
    this.__gesture_start_time = null;
    this.__gesture_end_time = null;
    this.__start_gesture_issued = false;
    this.__MAX_FRAME_COUNT_FOR_RESET = 15;
    this.__gesture_missing_frame_count = 0;
    this.time = new Date();
    this._first_ankle_point=0;
    this.gesture_issued_by = -1;
    // Remote control mode: the remote's START replaces the hand raise, so never detect one
    this.enabled = !isRemoteControl();
    this.boundary = -1;
    this.patient_crossed_boundary = false;
    this.offset = 30;
    this.KEYPOINT_RESULTS = {
        'x': 0,
        'y': 0,
        'score': 0,
        'name': ''
        }
    }
    
    __is_joint_above_shoulder( joint, shoulder){
        if ((joint !== null && shoulder !==null) 
            && joint.score > this.joint_confidence_threshold 
            && shoulder.score > this.joint_confidence_threshold)
        {
                if (joint.y < shoulder.y)
                {
                    return true;
                }
        }            
        return false
    }
    __getting_keypoints(keypoints,point)
    {
        for(var i=0;i<=keypoints.length-1;i++)
        {
            this.KEYPOINT_RESULTS=keypoints[i];
            if(this.KEYPOINT_RESULTS.name===point)
            {
                return this.KEYPOINT_RESULTS;
            }
        }
    }
    
    record_ankle_location(poses)
    {
        let ankle_list = [];
        for(let pose of poses)
        {
            let left_ankle = this.__getting_keypoints(pose.keypoints,'left_ankle');//pose[KEYPOINT_DICT['left_ankle']];
            let right_ankle = this.__getting_keypoints(pose.keypoints,'right_ankle');//pose[KEYPOINT_DICT['right_ankle']];
            ankle_list.push(left_ankle.y);
            ankle_list.push(right_ankle.y);
            // console.log("left_ankle, right_ankle:", left_ankle, right_ankle)
        }
        this.boundary = Math.max(...ankle_list)+this.offset;
        // console.log("this.boundary:", this.boundary)
    }
    
    __someone_raised_hand(poses){
        for(let pose of poses)
        {
            let left_elbow = this.__getting_keypoints(pose.keypoints,'left_elbow');//pose[KEYPOINT_DICT['left_elbow']];
            let right_elbow = this.__getting_keypoints(pose.keypoints,'right_elbow');//pose[KEYPOINT_DICT['right_elbow']];
            let left_wrist = this.__getting_keypoints(pose.keypoints,'left_wrist');//pose[KEYPOINT_DICT['left_wrist']];
            let right_wrist = this.__getting_keypoints(pose.keypoints,'right_wrist');//pose[KEYPOINT_DICT['right_wrist']];
            let left_shoulder = this.__getting_keypoints(pose.keypoints,'left_shoulder');//pose[KEYPOINT_DICT['left_shoulder']];
            let right_shoulder = this.__getting_keypoints(pose.keypoints,'right_shoulder');//pose[KEYPOINT_DICT['right_shoulder']];
            let left_ankle = this.__getting_keypoints(pose.keypoints,'left_ankle');//pose[KEYPOINT_DICT['left_ankle']];
            let right_ankle = this.__getting_keypoints(pose.keypoints,'right_ankle');//pose[KEYPOINT_DICT['right_ankle']];
            if(right_ankle.y>this.boundary || left_ankle.y>this.boundary){
                this.patient_crossed_boundary = true;
            }

            if (this.__is_joint_above_shoulder(left_elbow, left_shoulder) &&
                this.__is_joint_above_shoulder(left_wrist, left_shoulder)){
                return new RaisedHand('left',true, pose.id);
            }

            if (this.__is_joint_above_shoulder(right_elbow, right_shoulder) &&
                this.__is_joint_above_shoulder(right_wrist, right_shoulder)){
                    return new RaisedHand('right',true, pose.id);
                }
        }
        return new RaisedHand('',false, -1);
    }

    __detect_start_gesture(poses)
    {
        let hand_raised = this.__someone_raised_hand(poses);
        let raise_start_time = params.ASSESSMENT_STATUSES.Shoulder_time;

        if(hand_raised.raised){
            if (raise_start_time === '') {
                params.ASSESSMENT_STATUSES.Shoulder_time = new Date();
                params.ASSESSMENT_STATUSES.Direction = hand_raised.hand;
            }else{
                if (params.ASSESSMENT_STATUSES.Direction === hand_raised.hand) {
                    let current_time = new Date();
                    let time_diff = current_time - raise_start_time;
                    if (time_diff > 1000) {

                        this.gesture_issued_by = hand_raised.id;
                        this.__start_gesture_issued = true;
                        params.ASSESSMENT_STATUSES.Direction = '';
                        params.ASSESSMENT_STATUSES.Shoulder_time = '';
                        return;
                    }
                }else{
                    //switch hand, reset timer
                    params.ASSESSMENT_STATUSES.Shoulder_time = new Date();
                    params.ASSESSMENT_STATUSES.Direction = hand_raised.hand;
                }
            }
        }else{
            params.ASSESSMENT_STATUSES.Shoulder_time = '';
            params.ASSESSMENT_STATUSES.Direction = '';
        }
    }
    
    start_gesture_issued()
    {
        return this.__start_gesture_issued;
    }
        
    reset(){
        this.gesture_issued_by = -1;
        this.__start_gesture_issued = false;
        this.__gesture_end_time = null;
        this.__gesture_start_time = null;
        this.__gesture_missing_frame_count = 0;
        this.gesture_detected_frame_count = 0;
        params.ASSESSMENT_STATUSES.Shoulder_time = '';
        params.ASSESSMENT_STATUSES.Direction = '';
    }

    detect_start_gesture( poses)
    {
        if (this.__start_gesture_issued || !this.enabled)
            return
        this.__detect_start_gesture(poses);
    }

    _screen_color_change()
    {
        // Turning Screen Green
        var c =document.getElementById('output');
        var ctx = c.getContext("2d");
        ctx.beginPath();
        //ctx.setLineDash([10]);
        ctx.strokeStyle = 'green';
        ctx.lineWidth = "3";
        ctx.fillStyle = 'rgba(0,128,0,0.5)';
        ctx.fillRect(0, 0, c.width, c.height );
        ctx.rect(0, 0, c.width, c.height );
        ctx.stroke();
        ctx.closePath();
    }

}
export default GestureDetector;